<template>
    <pm-animations-layout :current-view="currentView" :gallery-id="galleryId">
        <template v-if="$store.state.animation.animationItems.length">

            <div id="main-container" class="app-content-container" style="background: rgb(248, 248, 248); padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);">
                <div style="position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; background: rgb(248, 248, 248); box-shadow: 0 -8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03);

                display: flex; flex-direction: column;"
                     :class="$theme.contentBg"
                >
                    <div style="flex-grow: 0; flex-shrink: 0;">
                        <pm-smart-animation-view class="x-pm-animation-fade-in-slide-down" v-if="selectedAnimation > 0"
                                                 :id="selectedAnimation"
                                                 ref="player"
                                                 :key="selectedAnimation"
                                                 @close="selectedAnimation = 0"
                        />
                    </div>

                    <div style="background: rgb(248, 248, 248); flex-grow: 1; flex-shrink: 1; padding: 0 0px 16px 0px; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">

                        <div v-show="currentView === 'all'">
                            <div style="padding: 16px; margin-top: 20px; background: #fff; box-shadow: rgba(243, 187, 1, 0.1) 0px 8px 15px;" v-for="(tag, tagIdx) in tags" :key="tag" class="x-pm-animation-fade-in-slide-down" :style="'--delay: ' + (tagIdx > 0 ? 700 : 0)  +'ms'">
                                <div style="margin-bottom: 12px; font-weight: 600; font-size: 14px; flex-grow: 1;" class="animation-tag">
                                    {{ $t(`tags.${tagsHash[tag]}`, $store.state.language) === 'tags.' ? tag : $t(`tags.${tagsHash[tag]}`, $store.state.language) }}
                                </div>
                                <pm-animation-list :category="tag" card-layout="vertical" @play="playAnimation" />
                            </div>
                        </div>

                        <div v-show="currentView === 'vs'">
                            <pm-animation-list v-once style="padding: 16px 16px 60px 16px;" category="Compare" card-layout="vertical" @play="playAnimation" />
                        </div>

                        <pm-animation-list style="padding: 16px 16px 60px 16px;" v-if="currentView === 'favourites'" :favourites="true" card-layout="vertical" @play="playAnimation" />

                        <!--pm-animation-list style="padding: 16px 16px 60px 16px;" v-else :key="currentView" :category="currentView === 'categories' ? tags[activeTagIdx] : ''" :favourites="currentView === 'favourites'" card-layout="vertical" @play="playAnimation" /-->
                        <!--pm-animation-list style="padding: 16px 16px 60px 16px;" v-show="" :key="currentView" :category="currentView === 'vs' ? 'Compare' : ''" :favourites="currentView === 'favourites'" card-layout="vertical" @play="playAnimation" /-->

                        <transition name="pm-fade-in-slide-up-transition">
                            <div v-show="currentView === 'categories'" style="will-change: opacity, transform; position: absolute; display: flex; top: auto; bottom: 0px; background: rgba(240,240,240,.8); box-shadow: 0 0 10px rgba(0,0,0,.35); border: 1px solid #fff; white-space: nowrap; width: 100vw; max-width: 100vw; overflow: scroll; scroll-snap-points-x: repeat(100vw); scroll-snap-type: mandatory; scroll-snap-type: x mandatory; z-index: 10" id="tag-container-bottom">

                                <div ref="tagsBottom" v-for="(tag, i) in tags" style="scroll-snap-align: start; width: 100vw; min-width: 100vw; text-align: center; position: relative;">
                                    <v-icon v-if="i>0" @click="prevTag" style="text-align: right; width: 60px; height: 65px; left: 0; position: absolute">chevron_left</v-icon>
                                    <span style="background: #fff; display: inline-block; text-align: center; margin: 15px 10px 15px 10px; border-radius: 20px; padding: 5px 15px 5px 15px; font-weight: 600; color: #000; box-shadow: 0 0 5px rgba(0,0,0,.1);">
                                        {{ i+1 }}. {{ tag }}
                                    </span>
                                    <v-icon v-if="i < tags.length - 1" @click="nextTag" style="text-align: left; width: 60px; height: 65px; right: 0; position: absolute">chevron_right</v-icon>
                                </div>

                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </template>

        <pm-app-loading-content-indicator v-else />

        <pm-premium-lock-screen v-if="locked && !$IAP.hasAccessToComponent('videos')" />
    </pm-animations-layout>
</template>

<style>
::-webkit-scrollbar {max-height: 0; height: 0; }

.pm-fade-in-slide-up-transition-leave-active {
    transition: opacity .3s, transform .3s;
    transform: translateY(0px);
}

.pm-fade-in-slide-up-transition-enter-active {
    transition: opacity .6s, transform .3s;
}

.pm-fade-in-slide-up-transition-enter-to {
    opacity: 1;
    transform: translateY(0px);
}

.pm-fade-in-slide-up-transition-enter, .pm-fade-in-slide-up-transition-leave-to {
    opacity: 0;
    transform: translateY(20px);
}





.pm-fade-in-slide-down-transition-leave-active {
    transition: opacity .3s, transform .3s;
    transform: translateY(0px);
}

.pm-fade-in-slide-down-transition-enter-active {
    transition: opacity .6s, transform .3s;
}

.pm-fade-in-slide-down-transition-enter-to {
    opacity: 1;
    transform: translateY(0px);
}

.pm-fade-in-slide-down-transition-enter, .pm-fade-in-slide-down-transition-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}


@media (min-width: 700px) {
    .animation-tag {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }
}
</style>

<script>

import {animationCategories} from "../../configs/animations";
import PmAnimationList from "./list";
import PmSmartAnimationView from "./view";
import PmAnimationsRouteBase from "./animations-route-base";
import PmAnimationTagsMixin from "./animation-tags-mixin";
import freeIds from "@/components/animations/freeIds";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";

export default {
    name: "PmModAnimations",
    extends: PmAnimationsRouteBase,
    mixins: [
        PmAnimationTagsMixin,
    ],
    components: {
        PmAnimationList,
        PmSmartAnimationView,
        PmPremiumLockScreen,
    },

    data: () => ({
        animationCategories,
        category: animationCategories[0],
        selectedAnimation: 0,
        locked: false,
    }),

    computed: {
        animationItems() {
            return this.$store.state.animation.animationItems;
        },
    },

    created() {
        this.$store.getters["animation/animationItems"];
    },

    deactivated() {
        // Unmount the videojs player
        const player = document.getElementById("animation-player");
        player && window.videojs(player).dispose();
        this.selectedAnimation = 0;
    },

    beforeDestroy() {
        // Unmount the videojs player
        const player = document.getElementById("animation-player");
        player && window.videojs(player).dispose();
    },

    watch: {
        currentView() {
            this.locked = false;
        }
    },
    methods: {
        playAnimation(id) {

            if (!this.$IAP.hasAccessToComponent('videos')) {
                this.locked = true;
                return;
            }

            // if (!this.$IAP.hasAccessToComponent('videos')) {
            //     this.$bus.$emit("free_trial:show", {
            //         countdown: 0,
            //         route: '/animations',
            //     });
            //     return;
            // }

            window.incrementLocalStorageForAnalyticsProp("videos_watched");
            if (this.$store.state.networkStatus === "offline") {
                this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("core.offline")});
                return;
            }
            this.selectedAnimation = id;
        },

    },
};

</script>
